/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as n from "react";
import { Draggable as a } from "@progress/kendo-react-common";
const o = ["n", "e", "s", "w", "se", "sw", "ne", "nw"];
class c extends n.Component {
  render() {
    return /* @__PURE__ */ n.createElement("div", { className: "k-resize-handles-wrapper" }, " ", o.map((t, r) => /* @__PURE__ */ n.createElement(
      a,
      {
        key: r,
        onDrag: (s) => {
          const { event: e } = s;
          e.originalEvent.preventDefault(), this.props.onResize(e, { end: !1, direction: t });
        },
        onRelease: (s) => {
          const { event: e } = s;
          e.originalEvent.preventDefault(), this.props.onResize(e, { end: !0, direction: t });
        }
      },
      /* @__PURE__ */ n.createElement(
        "div",
        {
          className: "k-resize-handle k-resize-" + t,
          style: { display: "block", touchAction: "none" }
        }
      )
    )));
  }
}
export {
  c as ResizeHandlers
};
